import { useEffect, useRef } from 'react';

/**
 *
 * @note TODO: This is temporarily here. This should be moved to bonfire
 * Returns previous value compared to previous render.
 */
const usePrevious = <T,>(value: T): T | undefined => {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
};

export default usePrevious;
